import React, { useEffect, useState, useRef } from "react";
import { FaTrophy, FaUsers, FaBalanceScale, FaCalendarCheck, FaStar } from "react-icons/fa";
import "./StatsSection.css";

const statsData = [
  { icon: <FaUsers />, label: "Clients Served", target: 1000 },
  { icon: <FaBalanceScale />, label: "Associates", target: 20 },
  { icon: <FaCalendarCheck />, label: "Years of Experience", target: 30 },
  { icon: <FaStar />, label: "Success Rate (%)", target: 98 },
];

const StatsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [counts, setCounts] = useState(statsData.map(() => 0));
  const sectionRef = useRef(null);

  // Observer to detect scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.5 }
    );

    const currentRef = sectionRef.current;
    if (currentRef) observer.observe(currentRef);

    return () => observer.disconnect();
  }, []);

  // Number counting animation when visible
  useEffect(() => {
    if (isVisible) {
      const intervals = statsData.map((stat, index) => {
        let currentCount = 0;
        const increment = stat.target / 100;

        return setInterval(() => {
          currentCount += increment;
          setCounts((prevCounts) => {
            const newCounts = [...prevCounts];
            newCounts[index] = Math.floor(currentCount);
            return newCounts;
          });

          if (currentCount >= stat.target) clearInterval(intervals[index]);
        }, 20);
      });

      return () => intervals.forEach((interval) => clearInterval(interval));
    }
  }, [isVisible]);

  return (
    <section ref={sectionRef} className={`stats-container ${isVisible ? "visible" : ""}`}>
      <div className="stats-header">
        <div className="stats-icon">
          <FaTrophy />
        </div>
        <h2>
          Proven <span>Success</span> in Numbers
        </h2>
      </div>

      <div className="stats-grid">
        {statsData.map((stat, index) => (
          <div className={`stat-card fade-in ${isVisible ? "show" : ""}`} key={index}>
            <div className="stat-icon">{stat.icon}</div>
            <h2 className="stat-counter">{counts[index]}+</h2> {/* Add + sign here */}
            <p>{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsSection;
